import MetalClient, { metalTypes } from '@atlassiansox/metal-client';

export function mapAMKTEnvToMetalEnv(amktEnv) {
  if (amktEnv === 'prod') {
    return metalTypes.Env.PROD;
  } else if (amktEnv === 'stg') {
    return metalTypes.Env.STAGING;
  } else if (amktEnv === 'dev') {
    return metalTypes.Env.DEV;
  } else {
    return metalTypes.Env.LOCAL;
  }
}

export function initMetalMonitoring(config) {
  const productInfo = {
    metalId: config.id,
    version: config.version,
    env: config.env,
  };

  new MetalClient({
    productInfo,
  });
}
